import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { MultiUserPreferencesEffects } from './multi-user-preferences-effects.service';
import { multiUserPreferencesFeature } from './multi-user-preferences.reducer';

@NgModule({
    declarations: [],
    imports: [
        StoreModule.forFeature(multiUserPreferencesFeature),
        EffectsModule.forFeature([MultiUserPreferencesEffects]),
    ],
})
export class MultiUserPreferencesStateModule {}
